/**
 * Asynchronously loads the component for UploadDataLeadConflictPage
 */

import { lazyLoad } from 'utils/loadable';

export const UploadDataLeadConflictPage = lazyLoad(
  () => import('./index'),
  module => module.UploadDataLeadConflictPage,
);
